import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCookie } from "./cookies";
import { configureAxios } from "./axiosConfig";
import {
  clearAuthSessionCookies,
  notifyAuthSessionChanged,
} from "../auth/utils/session";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    if (getCookie("accessToken")) {
      clearAuthSessionCookies();
      configureAxios();
      notifyAuthSessionChanged();
    }
    navigate("/login");
  }, [navigate]);
  return <div></div>;
}
